// extracted by mini-css-extract-plugin
export default {"customNavbar":"MainNavigation_customNavbar__QHMli"};